import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import React, {useState} from "react";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Tooltip from "@mui/material/Tooltip";
import {DeskingModal} from "../PricingListPage/DeskingModal";
import {DealRebateModal} from "../DealPage/DealRebateModal";
import {useModalsStore} from "../../stores/modalsStore";

export const RebatesTableRow = (props) => {
    const {
        rebate,
        leadingRebates,
        toggleRebate,
        isChecked,
        isLoading,
        isApplied,
    } = props

    const [checked, setChecked] = useState(isChecked)

    const openModal = useModalsStore((state) => state.openModal)

    useDidMountEffect(function checkRebate(){
        toggleRebate(rebate.external_id)
    }, [checked])

    return (
        <TableRow key={rebate.external_id}>
            <TableCell
                className={'header-cell'}
                align="left"
                width={'5%'}
            >
                <Checkbox
                    className={''}
                    onChange={() => setChecked(!checked)}
                    checked={isChecked}
                    disabled={isLoading}
                />
            </TableCell>
            <TableCell
                className={'header-cell'}
                align="left"
                width={'30%'}
                style={{textAlign: 'start'}}
            >
                {rebate.name}
            </TableCell>
            <TableCell
                width={'5%'}
            >
                <Tooltip title="Details" arrow placement={'top'}>
                    <DescriptionOutlinedIcon
                        className={'DescriptionIcon'}
                        onClick={() => {
                            openModal({
                                id: "DeskingModal",
                                element: DealRebateModal,
                                props: {
                                    rebate: rebate,
                                    name: rebate.name,
                                    description: rebate.name
                                }
                            })
                        }}
                    />
                </Tooltip>
            </TableCell>
            {
                leadingRebates.map((leadingRebate, idx) => {
                    const hasAmount = leadingRebate.compatible_rebate_ids.includes(rebate.external_id)
                    const amount = hasAmount ? rebate.amount.toDollarFormat() : 'N/A'

                    return (
                        <TableCell
                            key={`${leadingRebate.external_id}-${rebate.external_id}`}
                            className={'header-cell'}
                            align="left"
                            width={'10%'}
                            style={{
                                opacity: isApplied(rebate.external_id, leadingRebate.external_id) ? 1 : .5
                            }}
                        >
                            {amount}
                        </TableCell>
                    )
                })
            }
        </TableRow>
    )
}